export enum AppRoute {
  Companies = 'companies',
  Users = 'users',
  Forbidden = 'forbidden',
  ReturnProcess = 'ReturnProcess',
  DeliveryNotifications = 'deliveryNotifications',
  Dashboard = 'dashboard',
  News = 'news',
}
